import React, { Component } from "react";
import { Container, Button } from "react-bootstrap";
import "./About.css";

class About extends Component {
  render() {
    return (
      <div>
        <div className="banner_all">
          <Container>
            <h1>About</h1>
          </Container>
        </div>
        <Container>
          <div className="row">
            <div className="col-sm-6">
              <img
                className="about-images"
                src="assets/images/casino.jpg"
                alt=""
              />
            </div>
            <div className="col-sm-6">
              <h3>ABOUT OUR COMPANY</h3>
              <p>
                From the start, we identified a need in the business market and
                we have continued to meet this need for our clients in our
                universe of products. BBM UNIVERSAL is a south African company
                offering services for a variety of IT products, Point of sale,
                casino display and conference display media.
              </p>

              <p>
                With over 5 years’ experience, we provide our customers with
                excellent hardware and software support.
              </p>
              <br />
              <br />
              <Button
                className="button rounded-pill"
                variant="danger"
                size="lg"
                type="submit"
                href="/contact"
              >
                Contact Us
              </Button>
            </div>
          </div>
        </Container>
        <div className="col greybackground">
          <Container>
            <div className="row">
              <div className="col-sm-12">
                <h3 className="center-text"> What We Offer</h3>
              </div>
              <div className="col-sm-4 center-text">
                <img
                  src="assets/images/point-of-sale.svg"
                  alt=""
                  width="100px"
                />
                <h5>Point of sale</h5>
                <p>
                  Buy best, cheap point of sale system for small business,
                  retail & hospitality.
                </p>
              </div>
              <div className="col-sm-4 center-text">
                <img
                  src="assets/images/slot-machine.svg"
                  alt=""
                  width="100px"
                />
                <h5>Casino display</h5>
                <p>
                  Pick a winner with our digital display and casino control room
                  solutions
                </p>
              </div>
              <div className="col-sm-4 center-text">
                <img src="assets/images/video-call.svg" alt="" width="100px" />
                <h5>Conference display media</h5>
                <p>
                  Exhibition stands, Banner Advert Design, Social Media
                  Integration
                </p>
              </div>
            </div>
          </Container>
        </div>

        <div className="parallax">
          <section className="Overlay">
            <Container>
              <h5>Our team</h5>
              <p>
                The rich experience of our team along with patented technologies
                allow us to meet the expectations of our clients and provide
                them with high quality and reliability casino equipment’s, Pos
                system and software and web development with qualified technical
                support.
              </p>
              <h5> Our key products</h5>
              <p>
                Touch terminal, roulette board display, multiplayer electronic
                pc, media streaming, web and software development.
              </p>
            </Container>
          </section>
          <Container></Container>
        </div>

        <div
          style={{
            // height: "300px"
            // "background-color": "red"
            marginTop: "50px"
          }}
        >
          <Container>
            <h1>Our work process</h1>
            <br />
            <div className="row">
              <div className="col-sm-12 col-lg-2">
                <li className="page_nums">1</li>
              </div>
              <div className="col-sm-12 col-lg-10">
                <h4 className="nums_text">Meeting With The Customer</h4>
                <p className="nums_text">
                  The first meeting is very important to get acquainted and
                  discuss the main ideas of the project.
                </p>
              </div>

              <div className="col-sm-12 col-lg-2">
            <li className="page_nums">2</li>
            </div>
            <div className="col-sm-12 col-lg-10">
            <h4 className="nums_text">We Consider And Analyze The Work Plan</h4>
            <p className="nums_text">
              When we understand the main ideas, we proceed to discuss the work
              plan and analyze it.
            </p>
            </div>

            <div className="col-sm-12 col-lg-2">
            <li className="page_nums">3</li>

            </div>
            <div className="col-sm-12 col-lg-10">
            <h4 className="nums_text">Work Hard On The Project</h4>
            <p className="nums_text">
              Our professional team starts to work on your project and embody
              all details of the initial concept.
            </p>

            </div>

            <div className="col-sm-12 col-lg-2">
            <li className="page_nums">4</li>

            </div>
            <div className="col-sm-12 col-lg-10">
            <h4 className="nums_text">
              Once Again We Analyze And Check Everything
            </h4>
            <p className="nums_text">
              We meet, analyze and check the work we done on the project and
              make any necessary changes.
            </p>

            </div>

            <div className="col-sm-12 col-lg-2">
            <li className="page_nums">5</li>

            </div>
            <div className="col-sm-12 col-lg-10">
            <h4 className="nums_text">
              We Finish The Project And Send It To The Customer
            </h4>
            <p className="nums_text">
              The project is completed and we give it to our customer. We also
              ask for customer’s feedback.
            </p>

            </div>



            </div>

          </Container>
        </div>
      </div>
    );
  }
}

export default About;
